import React from "react";
import RawDataPreview from "./Pages/RawDataPreview";
import LoadingCircularProgress from "../LoadingCircularProgress";
import { PivotReport } from "../PivotTable/PivotReport";
import { SeriesChart } from "../Charts/SeriesChart";
import { Segmented } from "../Charts/Segmented";
import { YearlyTrendsChart } from "../Charts/YearlyTrendsChart";
import { SpeciesPie } from "../Charts/SpeciesPie";

const ReportsLayout = ({
  slug,
  definition,
  pivotModel,
  weekPicker,
  chartView,
  onCellClick,
  onRowClick,
  timeChart,
  rawData,
  onDownloadData,
  columnVisibilityModel,
  rawColumns,
  setColumnVisibilityModel,
  loading,
  timeZone,
  dataGridRef,
  registerChartExport,
}) => {
  const renderReport = () => {
    if (definition?.pivot && definition.kind === "chart") {
      if (loading) return <LoadingCircularProgress />;
      if (!pivotModel) return null;
      if (definition.view === "stackedBar") {
        return (
          <SeriesChart
            model={pivotModel}
            title={definition.title}
            registerChartExport={registerChartExport}
            mode="bar"
            controls={
              chartView && (
                <Segmented
                  label="Bars"
                  options={chartView.options.map((label, i) => ({ label, value: i }))}
                  value={chartView.value}
                  onChange={chartView.onChange}
                />
              )
            }
          />
        );
      }
      if (definition.view === "pie") {
        return <SpeciesPie model={pivotModel} title={definition.title} registerChartExport={registerChartExport} />;
      }
      if (definition.view === "yearlyTrends") {
        return (
          <YearlyTrendsChart model={pivotModel} title={definition.title} registerChartExport={registerChartExport} />
        );
      }
      if (definition.view === "abundance") {
        return (
          <SeriesChart
            model={pivotModel}
            title={definition.title}
            registerChartExport={registerChartExport}
            mode={timeChart.mode}
            hidden={timeChart.hidden}
            onToggle={timeChart.onToggle}
            controls={
              <>
                <Segmented
                  label="Chart type"
                  options={[
                    { label: "Line", value: "line" },
                    { label: "Bar", value: "bar" },
                  ]}
                  value={timeChart.mode}
                  onChange={timeChart.onMode}
                />
                <Segmented
                  label="Time grain"
                  options={timeChart.grains.map((g) => ({ label: g[0].toUpperCase() + g.slice(1), value: g }))}
                  value={timeChart.grain}
                  onChange={timeChart.onGrain}
                />
              </>
            }
          />
        );
      }
    }
    if (definition?.pivot) {
      return (
        <PivotReport
          model={pivotModel}
          loading={loading}
          title={definition.title}
          weekPicker={weekPicker}
          onCellClick={onCellClick}
        />
      );
    }
    switch (slug) {
      case "raw-data":
        return (
          <RawDataPreview
            dataGridRef={dataGridRef}
            data={rawData}
            onDownloadData={() => onDownloadData()}
            columnVisibilityModel={columnVisibilityModel}
            columns={rawColumns}
            setColumnVisibilityModel={setColumnVisibilityModel}
            onRowClick={onRowClick}
            loading={loading}
            timeZone={timeZone}
          />
        );
      default:
        return (
          <>
            <div>No report available yet</div>
            {loading && <LoadingCircularProgress />}
          </>
        );
    }
  };

  return <div style={{ height: "100%", width: "100%" }}>{renderReport()}</div>;
};

export default ReportsLayout;
